export const options = {
  btn: {
    unelevated: true,
    noCaps: true,
    textColor: 'primary'
  },
  btnPrimary: {
    unelevated: true,
    noCaps: true,
    color: 'primary'
  },
  btnPrimaryFlat: {
    flat: true,
    noCaps: true,
    // dense: true,
    color: 'primary'
  },
  btnWhite: {
    unelevated: true,
    noCaps: true,
    color: 'white',
    textColor: 'black'
  },
  btnWhiteAlert: {
    unelevated: true,
    noCaps: true,
    color: 'white',
    textColor: 'negative'
  },
  btnAlertOk: {
    // flat: true,
    unelevated: true,
    noCaps: true,
    color: 'warning',
    type: 'button'
  },
  btnAlertCancel: {
    flat: true,
    unelevated: true,
    noCaps: true,
    color: 'warning',
    type: 'button'
  },
  btnNegativeFlat: {
    flat: true,
    noCaps: true,
    // dense: true,
    color: 'negative'
  },
  btnDelete: {
    flat: true,
    unelevated: true,
    noCaps: true,
    color: 'negative',
    type: 'button'
  },
  btnDeleteOk: {
    // flat: true,
    unelevated: true,
    noCaps: true,
    color: 'negative',
    type: 'button'
  },
  btnDeleteCancel: {
    outline: true,
    unelevated: true,
    noCaps: true,
    color: 'negative',
    type: 'button'
  },
  btnOutline: {
    outline: true,
    noCaps: true,
    class: 'text-primary'
  },
  btnOutlineDark: {
    outline: true,
    noCaps: true,
    color: 'dark',
    class: 'custom-btn-outline'
  },
  btnRound: {
    // flat: true,
    unelevated: true,
    round: true,
    size: 'sm',
    // color: 'grey-1',
    textColor: 'grey-6'
  },
  btnRoundOutline: {
    outline: true,
    round: true,
    size: 'sm'
  },
  btnClose: {
    flat: true,
    round: true,
    dense: true,
    icon: 'close'
  },
  btnClearable: {
    flat: true,
    round: true,
    dense: true,
    icon: 'cancel',
    color: 'grey-5'
  },
  btnTableView: {
    unelevated: true,
    dense: true,
    noCaps: true,
    textColor: 'primary',
    class: 'q-px-sm text-caption',
    type: 'a',
    label: 'Lihat'
  },
  btnTableDelete: {
    unelevated: true,
    dense: true,
    noCaps: true,
    textColor: 'negative',
    class: 'q-px-sm text-caption'
  },
  btnToggle: {
    unelevated: true,
    noCaps: true,
    toggleColor: 'primary',
    class: 'custom-btn-toggle'
  },
  btnToggleOutline: {
    unelevated: true,
    noCaps: true,
    toggleColor: 'primary',
    class: 'custom-btn-toggle-outline'
  },
  btnToggleSquare: {
    unelevated: true,
    square: true,
    noCaps: true,
    toggleColor: 'primary',
    class: 'custom-btn-toggle-outline'
  },
  btnAddNew: {
    type: 'a',
    color: 'primary',
    // icon: 'add',
    unelevated: true,
    noCaps: true
  },
  btnAddNewPrimary: {
    type: 'a',
    color: 'primary',
    icon: 'add',
    unelevated: true,
    noCaps: true
  },
  btnAddNewOutline: {
    type: 'a',
    icon: 'add',
    outline: true,
    noCaps: true,
    color: 'dark',
    class: 'custom-btn-outline'
  },
  btnAddNewFlat: {
    type: 'a',
    icon: 'add',
    flat: true,
    noCaps: true,
    color: 'primary',
    class: 'q-pr-sm'
  },
  btnAddNewFlatRound: {
    type: 'a',
    icon: 'add_circle',
    flat: true,
    noCaps: true,
    color: 'primary',
    class: 'q-pr-sm'
  },
  btnDropdown: {
    noCaps: true,
    unelevated: true,
    align: 'center',
    color: 'primary',
    class: 'full-width'
  },
  input: {
    color: 'primary',
    outlined: true,
    clearable: true,
    dense: true
  },
  inputEmail: {
    color: 'primary',
    outlined: true,
    clearable: true,
    type: 'email',
    dense: true
  },
  inputPhone: {
    color: 'primary',
    outlined: true,
    clearable: true,
    type: 'tel',
    mask: '(##) ### - #### - #####',
    unmaskedValue: true,
    dense: true
  },
  inputNumber: {
    color: 'primary',
    outlined: true,
    clearable: true,
    type: 'number'
  },
  inputFile: {
    color: 'primary',
    outlined: true,
    clearable: true,
    noCaps: true,
    accept: '.jpg, image/*, .pdf',
    class: 'input-file-dashed'
  },
  inputFlat: {
    color: 'primary',
    borderless: true,
    dense: true,
    clearable: true
  },
  inputPassword: {
    color: 'primary',
    outlined: true,
    clearable: true,
    type: 'password',
    label: 'Password',
    autocorrect: 'off',
    autocapitalize: 'off',
    autocomplete: 'off',
    spellcheck: false
  },
  inputNPWP: {
    color: 'primary',
    outlined: true,
    clearable: true,
    placeholder: 'XX.XXX.XXX.X-XXX.XXX',
    mask: 'XX.XXX.XXX.X-XXX.XXX',
    unmaskedValue: true
  },
  inputCOA: {
    color: 'primary',
    outlined: true,
    clearable: true,
    placeholder: 'XXX.XX.XX.XX',
    mask: 'XXX.XX.XX.XX',
    unmaskedValue: true,
    maxlength: 12
  },
  inputFakturPajak: {
    color: 'primary',
    outlined: true,
    clearable: true,
    placeholder: 'XXX.XXX-XX.XXXXXXXX',
    mask: 'XXX.XXX-XX.XXXXXXXX',
    unmaskedValue: true
  },
  textarea: {
    outlined: true,
    clearable: true,
    color: 'primary',
    type: 'textarea'
  },
  select: {
    color: 'primary',
    outlined: true,
    useInput: true,
    emitValue: true,
    mapOptions: true,
    clearable: true,
    dense: true,
    // optionsDense: true,
    // behavior: 'menu',
    inputDebounce: '0',
    optionDisable: 'inactive'
  },
  innerLoading: {
    label: 'Please wait...',
    color: 'primary'
  },

  table: {
    hidePagination: true,
    flat: true,
    wrapCells: true,
    binaryStateSort: true,
    separator: 'cell',
    rowKey: 'name'
  },
  date: {
    todayBtn: true,
    mask: 'D MMM YYYY',
    color: 'primary'
  },
  cardForm: {
    flat: true,
    class: 'card-form card-form-border-xs'
  },
  cardListTable: {
    flat: true,
    class: 'card-list-table relative-position rounded-borders q-pa-lg'
  },
  cardDialog: {
    flat: true,
    class: 'card-dialog'
  },
  tabs: {
    noCaps: true,
    narrowIndicator: true,
    dense: true,
    align: 'left',
    activeColor: 'primary'
  },
  checkbox: {
    color: 'primary'
  },

  drawer: {
    flat: true,
    dense: true,
    round: true
  },
  badge: {
    rounded: true,
    color: 'blue-9'
  }
}
